<div class="users-page">
  @if (loading) {
  <div class="users-overlay-spinner">
    <p-progress-spinner [attr.aria-label]="'USERS.SPINNER_LOADING' | translate" />
  </div>
  }

  <header class="users-hero">
    <div class="users-hero__inner">
      <div class="users-hero__brand">
        <div class="users-hero__icon" aria-hidden="true">
          <i class="pi pi-users"></i>
        </div>
        <div class="users-hero__text">
          <span class="users-hero__eyebrow">{{ 'USERS.PAGE_SUBTITLE' | translate }}</span>
          <h1 class="users-hero__title">{{ 'USERS.PAGE_TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="users-hero__actions">
        @if (allUsers.length > 0) {
        <span class="users-hero__chip">
          <i class="pi pi-id-card" aria-hidden="true"></i>
          {{ 'USERS.LEADERS_COUNT' | translate: { count: allUsers.length } }}
        </span>
        }
        <p-button [label]="'USERS.ADD_LEADER' | translate" icon="pi pi-plus"
          styleClass="users-hero__btn users-hero__btn--cta" (click)="showModalDialog()" />
      </div>
    </div>
  </header>

  <article class="users-panel">
    <header class="users-panel__head">
      <div class="users-panel__icon users-panel__icon--brand">
        <i class="pi pi-shield"></i>
      </div>
      <div class="users-panel__titles">
        <h2 class="users-panel__title">{{ 'USERS.PANEL_TITLE' | translate }}</h2>
        <p class="users-panel__desc">{{ 'USERS.PANEL_DESC' | translate }}</p>
      </div>
    </header>

    <div class="users-panel__body">
      @if (allUsers.length === 0) {
      <div class="users-empty">
        <i class="pi pi-users" aria-hidden="true"></i>
        <p>{{ 'USERS.EMPTY_LIST' | translate }}</p>
        <p-button [label]="'USERS.ADD_LEADER' | translate" icon="pi pi-plus"
          styleClass="users-empty__btn" (click)="showModalDialog()" />
      </div>
      } @else {
      <div class="users-grid">
        @for (user of allUsers; track user.id) {
        <article class="users-card" [ngClass]="{
            'users-card--pastor': isPastorUser(user),
            'users-card--admin': getMainRoleKind(user) === 'ADMIN',
            'users-card--treasurer': getMainRoleKind(user) === 'TESORERIA',
            'users-card--secretary': getMainRoleKind(user) === 'SECRETARIA'
          }">
          <div class="users-card__avatar-wrap">
            @if (user.photoUrl) {
            <img [src]="user.photoUrl" [attr.alt]="getNombreCorto(user)" class="users-card__avatar">
            } @else {
            <div class="users-card__initials">
              {{ ((user.nombres || '').charAt(0) || '') + ((user.apellidos || '').charAt(0) || '') }}
            </div>
            }
          </div>

          <div class="users-card__body">
            <h3 class="users-card__name" [pTooltip]="(user.nombres || '') + ' ' + (user.apellidos || '')"
              tooltipPosition="top">
              {{ getNombreCorto(user) || ('USERS.NO_NAME' | translate) }}
            </h3>
            <p class="users-card__email" [pTooltip]="user.email" tooltipPosition="top">
              <i class="pi pi-envelope" aria-hidden="true"></i>
              {{ user.email || ('USERS.EMAIL_NONE' | translate) }}
            </p>

            <div class="users-card__roles">
              @if (!hasNoMainRole(user)) {
              <span class="users-role-badge users-role-badge--main">
                {{ getMainRoleLabel(user) }}
              </span>
              } @else {
              <span class="users-role-badge">{{ 'USERS.MAIN_ROLE_NONE' | translate }}</span>
              }

              @if (getAccessTags(user).length > 0) {
              <div class="users-card__access">
                <span class="users-card__access-label">{{ 'USERS.ACCESS_LABEL' | translate }}</span>
                <div class="users-card__access-tags">
                  @for (access of getAccessTags(user); track access) {
                  <span class="users-access-tag">{{ access }}</span>
                  }
                </div>
              </div>
              }
            </div>
          </div>

          @if (!isPastorUser(user)) {
          <footer class="users-card__footer">
            <p-button icon="pi pi-pencil" [label]="'USERS.BTN_EDIT' | translate"
              styleClass="users-card__action-btn" (click)="editUser(user)" />
            <p-button icon="pi pi-trash" [label]="'USERS.BTN_REMOVE' | translate"
              styleClass="users-card__action-btn users-card__action-btn--danger"
              (onClick)="confirmarRemocionLider(user)" />
          </footer>
          } @else {
          <footer class="users-card__footer users-card__footer--locked">
            <span class="users-card__locked-hint">
              <i class="pi pi-lock" aria-hidden="true"></i>
              {{ 'USERS.PASTOR_LOCKED' | translate }}
            </span>
          </footer>
          }
        </article>
        }
      </div>
      }
    </div>
  </article>
</div>

<p-dialog [(visible)]="displayModal" [modal]="true"
  [style]="{ width: modalStage === 'search' ? 'min(520px, 94vw)' : 'min(680px, 94vw)' }"
  styleClass="users-dialog" contentStyleClass="users-dialog__content"
  [draggable]="false" [dismissableMask]="true" [focusOnShow]="false" [appendTo]="'body'">

  <ng-template pTemplate="header">
    <div class="users-dialog__header">
      <span class="users-dialog__header-icon" aria-hidden="true">
        <i class="pi" [ngClass]="{
          'pi-search': modalStage === 'search',
          'pi-user-plus': modalStage === 'createUserAssignRole',
          'pi-user-edit': modalStage === 'editUserRoles'
        }"></i>
      </span>
      <div class="users-dialog__header-text">
        <span class="users-dialog__header-title">
          @if (modalStage === 'search') {
            {{ 'USERS.DIALOG_TITLE' | translate }}
          } @else if (modalStage === 'createUserAssignRole') {
            {{ 'USERS.DIALOG_CREATE_TITLE' | translate }}
          } @else {
            {{ 'USERS.EDIT_ROLES_TITLE' | translate }}
          }
        </span>
        <span class="users-dialog__header-sub">
          @if (modalStage === 'search') {
            {{ 'USERS.DIALOG_SEARCH_SUBTITLE' | translate }}
          } @else if (modalStage === 'createUserAssignRole') {
            {{ 'USERS.DIALOG_CREATE_SUBTITLE' | translate: { name: selectedMember?.nombres } }}
          } @else {
            {{ 'USERS.EDIT_ROLES_SUBTITLE' | translate: { name: selectedMember?.nombres } }}
          }
        </span>
      </div>
    </div>
  </ng-template>

  <!-- SEARCH -->
  @if (modalStage === 'search') {
  <div class="users-dialog__stage users-dialog__stage--search">
    <div class="users-dialog__search">
      <p-iconField class="w-100">
        <p-inputicon class="pi pi-search" />
        <input type="text" pInputText [(ngModel)]="searchTerm" [placeholder]="'USERS.SEARCH_PLACEHOLDER' | translate"
          class="w-100" [autofocus]="true" />
      </p-iconField>
    </div>

    @if (searchResults.length > 0) {
    <div class="users-dialog__results">
      <p class="users-dialog__results-count">{{ 'USERS.RESULTS_FOUND' | translate: { count: searchResults.length } }}</p>
      <div class="users-result-list">
        @for (member of searchResults; track member.id) {
        <button type="button" class="users-result-row" (click)="selectMember(member)">
          <span class="users-result-row__avatar">{{ member.nombres.charAt(0) }}</span>
          <span class="users-result-row__info">
            <span class="users-result-row__name">{{ member.nombres }}</span>
            @if (member.telefono) {
            <span class="users-result-row__meta">
              <i class="pi pi-phone" aria-hidden="true"></i>{{ member.telefono }}
            </span>
            }
          </span>
          <i class="pi pi-arrow-right users-result-row__chevron" aria-hidden="true"></i>
        </button>
        }
      </div>
    </div>
    } @else if (searchTerm) {
    <div class="users-dialog__empty">
      <i class="pi pi-search" aria-hidden="true"></i>
      <p>{{ 'USERS.NO_RESULTS_FOR' | translate: { term: searchTerm } }}</p>
    </div>
    } @else {
    <div class="users-dialog__empty">
      <i class="pi pi-users" aria-hidden="true"></i>
      <p>{{ 'USERS.SEARCH_HINT' | translate }}</p>
    </div>
    }
  </div>
  }

  <!-- CREATE -->
  @if (modalStage === 'createUserAssignRole') {
  <div class="users-dialog__stage users-dialog__form p-fluid">
    @if (selectedMember) {
    <div class="users-dialog__member-chip">
      <span class="users-dialog__member-chip-avatar">{{ selectedMember.nombres.charAt(0) }}</span>
      <span class="users-dialog__member-chip-name">{{ selectedMember.nombres }} {{ selectedMember.apellidos }}</span>
    </div>
    }

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--brand"><i class="pi pi-lock"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_CREDENTIALS' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <div class="row g-3">
          <div class="col-12">
            <p-floatLabel variant="on">
              <input pInputText id="email" [(ngModel)]="newUserEmail" class="w-100" />
              <label for="email">{{ 'USERS.FIELD_EMAIL' | translate }}</label>
            </p-floatLabel>
          </div>
          <div class="col-12">
            <p-floatLabel variant="on">
              <p-password inputId="password" [(ngModel)]="newUserPassword" [toggleMask]="true" [feedback]="false"
                styleClass="w-100" inputStyleClass="w-100"></p-password>
              <label for="password">{{ 'USERS.FIELD_PASSWORD' | translate }}</label>
            </p-floatLabel>
          </div>
        </div>
      </div>
    </section>

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--accent"><i class="pi pi-id-card"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_ROLES' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <div class="users-permission-grid">
          @for (role of availableRoles; track role.value) {
          <button type="button" class="users-permission-card" [class.users-permission-card--selected]="hasRole(role.value)"
            (click)="selectMainRole(role.value)">
            <span class="users-permission-card__title">{{ role.labelKey | translate }}</span>
            <span class="users-permission-card__check" aria-hidden="true">
              @if (hasRole(role.value)) { <i class="pi pi-check"></i> }
            </span>
          </button>
          }
        </div>
      </div>
    </section>

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--finance"><i class="pi pi-shield"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_ACCESS' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <div class="users-permission-grid">
          @for (permission of availablePermissions; track permission.value) {
          <button type="button" class="users-permission-card"
            [class.users-permission-card--selected]="hasRole(permission.value)"
            [class.users-permission-card--locked]="isPermissionLocked(permission.value)"
            (click)="togglePermission(permission.value)">
            <span class="users-permission-card__title">{{ permission.labelKey | translate }}</span>
            <span class="users-permission-card__check" aria-hidden="true">
              @if (isPermissionLocked(permission.value)) { <i class="pi pi-lock"></i> }
              @else if (hasRole(permission.value)) { <i class="pi pi-check"></i> }
            </span>
          </button>
          }
        </div>
      </div>
    </section>
  </div>
  }

  <!-- EDIT -->
  @if (modalStage === 'editUserRoles') {
  <div class="users-dialog__stage users-dialog__form p-fluid">
    @if (selectedMember) {
    <div class="users-dialog__member-chip">
      <span class="users-dialog__member-chip-avatar">{{ selectedMember.nombres.charAt(0) }}</span>
      <span class="users-dialog__member-chip-name">{{ selectedMember.nombres }} {{ selectedMember.apellidos }}</span>
    </div>
    }

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--brand"><i class="pi pi-lock"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_CREDENTIALS' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <p class="users-dialog__hint">{{ 'USERS.EDIT_PASSWORD_HINT' | translate }}</p>
        <div class="row g-3">
          <div class="col-12">
            <p-floatLabel variant="on">
              <p-password inputId="edit-new-password" [(ngModel)]="editNewPassword" [toggleMask]="true"
                [feedback]="false" styleClass="w-100" inputStyleClass="w-100"
                autocomplete="new-password"></p-password>
              <label for="edit-new-password">{{ 'USERS.FIELD_NEW_PASSWORD' | translate }}</label>
            </p-floatLabel>
          </div>
        </div>
      </div>
    </section>

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--accent"><i class="pi pi-id-card"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_ROLES' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <div class="users-permission-grid">
          @for (role of availableRoles; track role.value) {
          <button type="button" class="users-permission-card" [class.users-permission-card--selected]="hasRole(role.value)"
            (click)="selectMainRole(role.value)">
            <span class="users-permission-card__title">{{ role.labelKey | translate }}</span>
            <span class="users-permission-card__check" aria-hidden="true">
              @if (hasRole(role.value)) { <i class="pi pi-check"></i> }
            </span>
          </button>
          }
        </div>
      </div>
    </section>

    <section class="users-dialog__section">
      <header class="users-dialog__section-head">
        <span class="users-dialog__section-icon users-dialog__section-icon--finance"><i class="pi pi-shield"></i></span>
        <h3 class="users-dialog__section-title">{{ 'USERS.SECTION_ACCESS' | translate }}</h3>
      </header>
      <div class="users-dialog__section-body">
        <div class="users-permission-grid">
          @for (permission of availablePermissions; track permission.value) {
          <button type="button" class="users-permission-card"
            [class.users-permission-card--selected]="hasRole(permission.value)"
            [class.users-permission-card--locked]="isPermissionLocked(permission.value)"
            (click)="togglePermission(permission.value)">
            <span class="users-permission-card__title">{{ permission.labelKey | translate }}</span>
            <span class="users-permission-card__check" aria-hidden="true">
              @if (isPermissionLocked(permission.value)) { <i class="pi pi-lock"></i> }
              @else if (hasRole(permission.value)) { <i class="pi pi-check"></i> }
            </span>
          </button>
          }
        </div>
      </div>
    </section>
  </div>
  }

  <ng-template pTemplate="footer">
    <div class="users-dialog__footer">
      <p-button [label]="'USERS.BTN_CANCEL' | translate" icon="pi pi-times"
        styleClass="users-dialog__btn-cancel" (click)="cancelAssignment()" />
      @if (modalStage === 'createUserAssignRole') {
      <p-button [label]="'USERS.BTN_CREATE_AND_ASSIGN' | translate" icon="pi pi-check"
        styleClass="users-dialog__btn-save" (click)="createUserAndAssignRoles()" />
      } @else if (modalStage === 'editUserRoles') {
      <p-button [label]="'USERS.BTN_SAVE_CHANGES' | translate" icon="pi pi-save"
        styleClass="users-dialog__btn-save" (click)="saveUpdateRoles()" />
      }
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="'USERS.DIALOG_NESTED_TITLE' | translate" [modal]="true" [(visible)]="modalConfirm"
  [style]="{ width: '25rem' }" styleClass="users-nested-dialog">
  <span class="users-nested-dialog__ok">{{ 'USERS.DIALOG_NESTED_OK' | translate }}</span>
  <p class="users-nested-dialog__body">{{ 'USERS.DIALOG_NESTED_BODY' | translate: { name: selectedMember?.nombres } }}</p>
  <ng-template pTemplate="footer">
    <p-button [label]="'USERS.DIALOG_NESTED_CLOSE' | translate" (click)="modalConfirm = false" />
  </ng-template>
</p-dialog>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>
<p-toast></p-toast>
